






import { SvgIcon } from './svg-icon';
export default SvgIcon;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/svg-icon.vue